// extracted by mini-css-extract-plugin
export var alignCenter = "_6o-d";
export var bannerShown = "_6o-6";
export var buttonContent = "_6o-0";
export var cardList = "_6o-1";
export var centerContent = "_6o-2";
export var chevron = "_6o-3";
export var closePanelButton = "_6o-k";
export var conversationContextContainer = "_6o-l";
export var conversationDetailContainer = "_6o-4";
export var detailWrapper = "_6o-7";
export var dropdownButton = "_6o-e";
export var dropdownTitle = "_6o-9";
export var fullHeight = "_6o-5";
export var hidden = "_6o-a";
export var icon = "_6o-b";
export var mergeSuggestionWrapper = "_6o-m";
export var panel = "_6o-i";
export var portalButtonsWrapper = "_6o-c";
export var right = "_6o-j";
export var tableSummaryContainer = "_6o-8";
export var tableSummaryHeader = "_6o-g";
export var threeDotsButton = "_6o-f";
export var wide = "_6o-h";